<template>
  <div>
    <h1>Pasajeros</h1>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="name"   class="form-control" placeholder="Nombres"></b-form-input>
             <b-input-group-append>
              <b-button :disabled="!name" @click="name = ''; lastName = ''; busqueda ()">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
          <br>
          <b-input-group>
            <b-form-input v-model="lastName" class="form-control" placeholder="Apellidos"></b-form-input>
             <b-input-group-append>
              <b-button :disabled="!lastName" @click="busqueda">Buscar</b-button>
            </b-input-group-append>
          </b-input-group>
          <br>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Registros por pagina" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="4" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input :disabled="!phoneNumber==''" v-model="email" class="form-control" placeholder="Correo electronico"></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
       <b-col md="4" class="my-1">
        <b-input-group>
             <b-form-input :disabled="!email==''" v-model="phoneNumber" placeholder="Número de teléfono" class="form-control" ></b-form-input>
          </b-input-group>
      </b-col>
      <b-col md="2" class="my-1">
          <b-input-group-append>
            <b-button @click="email = ''; phoneNumber = ''; reset ()">Limpiar</b-button>
            <b-button @click="searchEmail (); searchPhoneNumber ()"  style="left: 20px; position: relative;">Buscar</b-button>
            </b-input-group-append>
      </b-col>
      <b-table
          show-empty
          stacked="md"
          :items="getAllPassengers"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :name="name"
          :lastName="lastName"
          :email="email"
          :phoneNumber="phoneNumber"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
          empty-text="No existen registros por mostrar"
          emptyFilteredText="No existen registros por mostrar"
        >

          <template v-slot:cell(active)='row'>
            <p>{{row.item.active === 1 ? 'Activo' : 'Inactivo'}}</p>
          </template>
          <template v-slot:cell(phoneNumber)='row'>
            {{ row.item.phoneNumber.replace('+52', '') }}
          </template>
        </b-table>

        <b-row>
          <b-col md="6" class="my-1">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
    </b-row>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const GET_NAME_LAST_NAME = gql`
  query searchPassenger($name:String, $lastName:String){
     searchPassenger(name: $name lastName: $lastName){
        name
        lastName
        email
        phoneNumber
        active
    }
  }
`
const GET_PHONE_NUMBER = gql`
  query getonePassengerbyphoneNumber($phoneNumber:String){
     getonePassengerbyphoneNumber(phoneNumber: $phoneNumber){
        name
        lastName
        email
        phoneNumber
        active
    }
  }
`
const GET_EMAIL = gql`
  query getPassengerByEmail($email:String){
     getPassengerByEmail(email: $email){
        name
        lastName
        email
        phoneNumber
        active
    }
  }
`
const GET_ALL = gql`
  query getAllPassengers{
          getAllPassengers{
            id
            name
            lastName
            email
            phoneNumber
            active
          }
        }
      `
export default {
  name: 'Passengers',
  data() {
    return {
      fields: [
        // { key: 'id', label: 'Id' },
        { key: 'name', label: 'Nombre(s)' },
        { key: 'lastName', label: 'Apellidos' },
        { key: 'email', label: 'Correo electrónico' },
        { key: 'phoneNumber', label: 'Número de teléfono' },
        // { key: 'active', label: 'Estatus' },
      ],
      totalRows: 5,
      currentPage: 1,
      perPage: 50,
      pageOptions: [10, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      name: null,
      lastName: null,
      email: null,
      phoneNumber: null,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      getAllPassengers: [],
    }
  },
  apollo: {
    getAllPassengers: {
      query: gql`
        query getAllPassengers{
          getAllPassengers{
            id
            name
            lastName
            email
            phoneNumber
            active
          }
        }
      `,
      context: headers(),
      result({ data }) {
        this.totalRows = this.getAllPassengers.length
      },
      error(error) {
        console.log(error)
      },
    },
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    busqueda() {
      if (this.name !== null && this.lastName !== null) {
        if (this.name !== '' && this.lastName !== '') {
          this.getNames()
        } else {
          this.getall()
        }
      } else {
        this.getall()
      }
    },
    searchPhoneNumber() {
      if (this.phoneNumber !== null) {
        if (this.phoneNumber !== '') {
          this.getPhoneNumber()
        }
      }
    },
    searchEmail() {
      if (this.email !== null) {
        if (this.email !== '') {
          this.getEmail()
        }
      }
    },
    reset() {
      if (this.phoneNumber !== null && this.email !== null) {
        if (this.phoneNumber !== '' && this.email !== '') {
          this.getall()
        } else {
          this.getall()
        }
      }
    },
    getall() {
      this.$apollo.query({
        query: GET_ALL,
        context: headers(),
      })
        .then(({ data }) => {
          console.log(data)
          this.totalRows = data.getAllPassengers.length
          this.$apollo.queries.getAllPassengers.skip = true
          this.getAllPassengers = data.getAllPassengers
        })
    },
    getNames() {
      this.$apollo.query({
        query: GET_NAME_LAST_NAME,
        variables: {
          name: this.name,
          lastName: this.lastName,
        },
        context: headers(),
      })
        .then(({ data }) => {
          console.log(data)
          if (data.searchPassenger === null) {
            this.makeToast(true, 'warning', 'Sin resultados', 'Sin resultados para mostrar. Verifica que los datos ingresados sean correctos.')
            console.log('sin datos')
          }
          var list = []
          list.push(data.searchPassenger)
          console.log(list)
          this.totalRows = data.searchPassenger.length
          this.$apollo.queries.getAllPassengers.skip = true
          this.getAllPassengers = list
        })
    },
    getPhoneNumber() {
      this.$apollo.query({
        query: GET_PHONE_NUMBER,
        variables: {
          phoneNumber: '+52' + this.phoneNumber,
        },
        context: headers(),
      })
        .then(({ data }) => {
          console.log(data)
          if (data.getonePassengerbyphoneNumber === null) {
            this.makeToast(true, 'warning', 'Sin resultados', 'Sin resultados para mostrar. Verifica que los datos ingresados sean correctos.')
            console.log('sin datos')
          }
          var list = []
          list.push(data.getonePassengerbyphoneNumber)
          console.log(list)
          this.totalRows = data.getonePassengerbyphoneNumber.length
          this.$apollo.queries.getAllPassengers.skip = true
          this.getAllPassengers = list
        })
    },
    getEmail() {
      this.$apollo.query({
        query: GET_EMAIL,
        variables: {
          email: this.email,
        },
        context: headers(),
      })
        .then(({ data }) => {
          console.log(data)
          if (data.getPassengerByEmail === null) {
            this.makeToast(true, 'warning', 'Sin resultados', 'Sin resultados para mostrar. Verifica que los datos ingresados sean correctos.')
            console.log('sin datos')
          }
          var list = []
          list.push(data.getPassengerByEmail)
          console.log(list)
          this.totalRows = data.getPassengerByEmail.length
          this.$apollo.queries.getAllPassengers.skip = true
          this.getAllPassengers = list
        })
    },
    makeToast(append = false, variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 4000,
        appendToast: append,
        variant: variant,
      })
    },
  },
}
</script>
<style scoped>

</style>
